class Processing {
  constructor(api) {
    this.api = api;
  }

  getList(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("/v1/processing")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  runProcessing(endpoint, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .patch("/v1/processing/" + endpoint, data, {
        headers: {
          workspaceuuid: sessionStorage.getItem("workspace_uuid") || ""
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default Processing;



// WEBPACK FOOTER //
// ./src/api/processing.js